import axios from "axios";
import { getApiBaseURL } from "./apiBaseUrl";

const STORAGE_TOKEN = "clientPortalToken";
const STORAGE_COMPANY = "clientPortalCompany";

export const clientPortalApi = axios.create({
  baseURL: getApiBaseURL(),
  headers: { "Content-Type": "application/json" },
});

clientPortalApi.interceptors.request.use((config) => {
  const company =
    config.headers?.Company ||
    config.headers?.company ||
    localStorage.getItem(STORAGE_COMPANY) ||
    localStorage.getItem("company") ||
    "";
  if (company) {
    config.headers.Company = company;
  }
  const token = localStorage.getItem(STORAGE_TOKEN);
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setClientPortalSession({ token, company }) {
  if (token) localStorage.setItem(STORAGE_TOKEN, token);
  if (company) localStorage.setItem(STORAGE_COMPANY, company);
}

export function clearClientPortalSession() {
  localStorage.removeItem(STORAGE_TOKEN);
  localStorage.removeItem(STORAGE_COMPANY);
}

export function getClientPortalCompany() {
  return localStorage.getItem(STORAGE_COMPANY) || "";
}

export function getClientPortalToken() {
  return localStorage.getItem(STORAGE_TOKEN) || "";
}

export async function portalBootstrap(company) {
  const { data } = await clientPortalApi.get("/portal-cliente/bootstrap", {
    params: { company },
    headers: { Company: company },
  });
  return data?.data || data;
}

export async function portalLogin({ email, password, company }) {
  const { data } = await clientPortalApi.post(
    "/portal-cliente/auth/login",
    { email, password },
    { headers: { Company: company } }
  );
  return data?.data || data;
}

export async function portalForgotPassword({ email, company }) {
  const { data } = await clientPortalApi.post(
    "/portal-cliente/auth/forgot-password",
    { email },
    { headers: { Company: company } }
  );
  return data;
}

export async function portalValidatePasswordToken(token, company) {
  const opts = company
    ? { headers: { Company: company }, params: { company } }
    : undefined;
  const { data } = await clientPortalApi.post(
    "/portal-cliente/auth/validate-password-token",
    { token },
    opts
  );
  return data;
}

export async function portalCompletePassword({ token, password, company }) {
  const opts = company
    ? { headers: { Company: company }, params: { company } }
    : undefined;
  const { data } = await clientPortalApi.post(
    "/portal-cliente/auth/complete-password",
    { token, new_password: password },
    opts
  );
  return data;
}

export async function portalMe() {
  const { data } = await clientPortalApi.get("/portal-cliente/auth/me");
  return data?.data || data;
}

export async function portalListTickets(status) {
  const params = status ? { status } : {};
  const { data } = await clientPortalApi.get("/portal-cliente/tickets", { params });
  return data?.data || data;
}

export async function portalGetTicket(id) {
  const { data } = await clientPortalApi.get(`/portal-cliente/tickets/${id}`);
  return data?.data || data;
}

export async function portalGetTicketMessages(id, { before, after, limit = 50 } = {}) {
  const params = {};
  if (before != null) params.before = before;
  if (after != null) params.after = after;
  if (limit != null) params.limit = limit;
  const { data } = await clientPortalApi.get(`/portal-cliente/tickets/${id}/messages`, { params });
  const payload = data?.data || data;
  return {
    messages: payload?.messages || [],
    hasMore: Boolean(payload?.hasMore),
    nextBefore: payload?.nextBefore ?? null,
    nextAfter: payload?.nextAfter ?? null,
  };
}

export async function portalCreateTicket(body) {
  const { data } = await clientPortalApi.post("/portal-cliente/tickets", body);
  return data?.data || data;
}

export async function portalPostMessage(ticketId, payload) {
  const body = typeof payload === "string" ? { message: payload } : payload;
  const { data } = await clientPortalApi.post(`/portal-cliente/tickets/${ticketId}/messages`, body);
  return data?.data || data;
}

export async function portalReopenTicket(ticketId) {
  const { data } = await clientPortalApi.post(`/portal-cliente/tickets/${ticketId}/reopen`);
  return data?.data || data;
}
